import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './accordion.scss?inline';

declare global {
    interface HTMLElementEventMap {
        'accordion-item-toggle': CustomEvent;
    }
}

@customElement('lit-accordion')
export class LitAccordion extends LitElement {

    // Import styles
    static styles = [unsafeCSS(style)];
    static shadowRootOptions: ShadowRootInit = { mode: 'closed' };

    private openItem: HTMLElement | null = null;

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('accordion-item-toggle', this.handleAccordionOpen.bind(this));
    }

    private handleAccordionOpen(event: CustomEvent) {
        const targetItem = event.target as HTMLElement; // Typcasting auf HTMLElement

        // close all other accordion items
        this.querySelectorAll('lit-accordion-item').forEach((item) => {
            if (item !== targetItem) {
                (item as any).close();
            }
        });

        this.openItem = targetItem;
    }

    render() {
        return html`
            <div class='accordion'>
                <slot></slot>
            </div>
        `;
    }
}
